<template>
    <div>
        <tool-bar class="bg-FFFFFF" title="Repayment"></tool-bar>

        <div class="padding-15">
            <div class="h-200 radius-25 bg-FFFFFF line-height-200">

                <div class="flex-h flex-v-center flex-h-center">
                    <img class="h-25 w-25 margin-t-30"
                         src="../../assets/icon_amount.png">
                    <span class="color-47494A font-18 font-bold line-height-17 margin-l-11 margin-t-30">
                        Repayment amount
                    </span>
                </div>

                <div class="font-bold font-40 color-14171B line-height-36 margin-t-28" style="text-align: center">
                    ₦{{formatCharacter(applicationInfo.orderInfo.repaymentRemainAmount)}}
                </div>

                <div class="margin-l-55 margin-r-55 h-line-E6E8EB margin-t-15"></div>

                <div class="color-888F99 font-bold font-15 line-height-14-5 margin-t-22" style="text-align: center">
                    Total repayable amount : ₦{{formatCharacter(applicationInfo.orderInfo.overdueAmount)}}
                </div>

            </div>


            <div class="radius-25 bg-FFFFFF margin-t-15" style="padding-bottom: 30px;">
                <div class="padding-h-15 padding-t-35">
                    <div class="flex-h flex-space-between flex-v-center">
                        <div class="font-16 font-bold color-888F99 line-height-12-5">
                            Loan amount
                        </div>

                        <div class="font-16 font-bold color-14171B line-height-12-5">
                            ₦{{formatCharacter(applicationInfo.loanAmount)}}
                        </div>
                    </div>
                    <div class="flex-h flex-space-between flex-v-center margin-t-26">
                        <div class="font-16 font-bold color-888F99 line-height-12-5">
                            Loan term
                        </div>
                        <div class="font-16 font-bold color-14171B line-height-12-5">
                            {{applicationInfo.loanTimeLimit}}days
                        </div>
                    </div>
                    <div class="flex-h flex-space-between flex-v-center margin-t-26">
                        <div class="font-16 font-bold color-888F99 line-height-12-5">
                            Interest(Received)
                        </div>
                        <div class="font-16 font-bold color-14171B line-height-12-5">
                            ₦{{formatCharacter(applicationInfo.interest)}}
                        </div>
                    </div>
                    <div class="flex-h flex-space-between flex-v-center margin-t-26">
                        <div class="font-16 font-bold color-888F99 line-height-12-5">
                            Service fee(Received)
                        </div>
                        <div class="font-16 font-bold color-14171B line-height-12-5">
                            ₦{{formatCharacter(applicationInfo.auditServiceExpense)}}
                        </div>
                    </div>
                </div>

                <div class="margin-l-15 margin-r-15 h-line-E6E8EB margin-t-26"></div>

                <div v-show="applicationInfo.orderInfo.overdueDays > 0">
                    <div class="padding-h-15">
                        <div class="flex-h flex-space-between flex-v-center margin-t-26">
                            <div class="font-16 font-bold color-888F99 line-height-12-5">
                                Overdue fee
                            </div>
                            <div class="font-16 font-bold color-E34443 line-height-12-5">
                                + ₦{{formatCharacter(applicationInfo.orderInfo.overduePayment)}}
                            </div>
                        </div>

                        <div class="flex-h flex-space-between flex-v-center margin-t-26">
                            <div class="font-16 font-bold color-888F99 line-height-12-5">
                                Overdue date
                            </div>
                            <div class="font-16 font-bold color-E34443 line-height-12-5">
                                {{Math.abs(applicationInfo.orderInfo.overdueDays)}}days
                            </div>
                        </div>
                    </div>
                </div>

                <span class="radius-15 bg-F2F4F7 margin-t-25 margin-h-15 font-14
                h-70 font-bold color-888F99 padding-l-15 flex-h flex-v-center">
                    Overdue will be recorded by credit bureau, please repay as soon
                </span>

            </div>
        </div>

        <div class="bg-FFFFFF h-71 flex-v flex-h-center font-bold"
             style="position: fixed;bottom: 0;width: 100%">
            <div class="padding-h-15">
                <van-button class="w-p-100"
                            style="height: 55px;border-radius: 8px;font-size: 19px;"
                            color="linear-gradient(to right,#1093FF, #69BBFF)"
                            @click="repayment_methods()"
                            block>
                    Repay
                </van-button>
            </div>
        </div>
    </div>
</template>

<script>
    import format from "@/utils/tools";

    export default {
        name: "repayment_detail",
        data() {
            return {
                applicationId: '',
                applicationInfo: {
                    loanAmount: 0,
                    loanTimeLimit: 0,
                    interest: 0,
                    auditServiceExpense: 0,
                    orderInfo: {
                        overdueDays: 0,
                        repaymentRemainAmount: 0,
                        overdueAmount: 0,
                        overduePayment: 0
                    }
                }
            }
        },
        mounted() {
            this.applicationId = this.$route.query.applicationId
            console.log(this.applicationId)
            this.getApplicationInfo()
        },
        beforeRouteEnter(to, from, next) {
            // 添加背景色
            document.querySelector('body').setAttribute('style', 'background-color:#F5F7FA')
            next()
        },
        beforeRouteLeave(to, from, next) {
            //去除背景色
            document.querySelector('body').setAttribute('style', '')
            next()
        },
        methods: {
            repayment_methods() {
                this.$router.push({
                    path: 'repayment_methods',
                    query: {
                        amount: this.applicationInfo.orderInfo.repaymentRemainAmount
                    }
                })
            },
            getApplicationInfo() {
                this.$showLoading()
                this.$request.getApplicationInfo(this.applicationId)
                    .then((res) => {
                        this.$hideLoading()
                        this.applicationInfo = res
                    })
                    .catch(() => {
                        this.$hideLoading()
                    })
            },
            formatCharacter(character) {
                return format.formatCharacter(character)
            }
        }
    }
</script>

<style scoped>

</style>